module.exports = __webpack_public_path__ + "static/media/1013513.dba467d4.jpg";